




















// eslint-disable-next-line
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class TourialFrame extends Vue {
  @Prop()
  iframeUrl!: string

  @Prop()
  tourialSlug!: string

  @Prop()
  initialize!: boolean

  @Prop()
  frameWidth: string | undefined

  @Watch('initialize')
  startDemo(isStarted: boolean) {
    if (isStarted) {
      this.createScript();
      this.resizeTourial();
    }
  }

  createScript() {
    const script = document.createElement('script');
    script.src = 'https://netwrix.tourial.com/embed.js';
    script.setAttribute('tourialSlug', this.tourialSlug);
    script.onload = () => {
      console.log('Script loaded successfully');
    };

    script.onerror = () => {
      console.log('Error occurred while loading script');
    };

    document.body.appendChild(script);
  }

  resizeTourial() {
    const timer = setInterval(() => {
      const tourialCont = document.getElementById('tourial-5fbe5d7b-77da-448b-aa4e-6e6db55b0360') as HTMLElement;

      // eslint-disable-next-line radix
      if (tourialCont && tourialCont.clientHeight < 200) {
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        }, 2000);
      } else {
        clearInterval(timer);
      }
    }, 500);
  }
}
